import React from "react";
import { Button } from "@/components/ui/button";
import { Instagram, Facebook } from "lucide-react";

type SocialShareButtonsProps = {
  shareOnSocial: (platform: string) => void;
};

export const SocialShareButtons: React.FC<SocialShareButtonsProps> = ({ shareOnSocial }) => {
  return (
    <div className="space-y-4 mb-8">
      <Button
        onClick={() => shareOnSocial("instagram")}
        className="w-full bg-gradient-to-r from-purple-500 to-pink-500 hover:opacity-90 flex gap-3 items-center justify-center h-12 text-white"
      >
        <Instagram className="w-5 h-5" />
        Add to Instagram Bio
      </Button>
      
      <Button
        onClick={() => shareOnSocial("facebook")}
        className="w-full bg-[#1877F2] hover:opacity-90 flex gap-3 items-center justify-center h-12 text-white"
      >
        <Facebook className="w-5 h-5" />
        Share on Facebook
      </Button>
      
      <Button
        onClick={() => shareOnSocial("whatsapp")}
        className="w-full bg-[#25D366] hover:opacity-90 flex gap-3 items-center justify-center h-12 text-white"
      >
        <img 
          src="/icons8-whatsapp.svg" 
          alt="WhatsApp" 
          className="w-5 h-5" 
          style={{ filter: 'brightness(0) invert(1)' }} 
        />
        Share on WhatsApp
      </Button>
    </div>
  );
};
